<template>
  <div class="row response_table">
     <table>
      <thead>
        <tr>
          <th
              class="pointer task-name"
              @click="change_filter('name')"
              :class="{ selected: filter_type === 'name' }"
              scope="col"
          >
            {{ translate('task.name_task') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer w7per"
              @click="change_filter('count')"
              :class="{ selected: filter_type === 'count' }"
              scope="col"
          >
            {{ translate('task.count_mm') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer w7per"
              @click="change_filter('count_success')"
              :class="{ selected: filter_type === 'count_success' }"
              scope="col"
          >
            {{ translate('task.count_success') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer w7per"
              @click="change_filter('count_pending')"
              :class="{ selected: filter_type === 'count_pending' }"
              scope="col"
          >
            {{ translate('task.count_pending') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer w7per"
              @click="change_filter('count_failed')"
              :class="{ selected: filter_type === 'count_failed' }"
              scope="col"
          >
            {{ translate('task.count_failed') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer w7per"
              @click="change_filter('count_cancelled')"
              :class="{ selected: filter_type === 'count_cancelled' }"
              scope="col"
          >
            {{ translate('task.count_cancelled') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer"
              @click="change_filter('status')"
              :class="{ selected: filter_type === 'status' }"
              scope="col"
          >
            {{ translate('task.status') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer"
              @click="change_filter('user_name')"
              :class="{ selected: filter_type === 'user_name' }"
              scope="col"
          >
            {{ translate('task.username') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
          <th
              class="pointer"
              @click="change_filter('ts_create')"
              :class="{ selected: filter_type === 'ts_create' }"
              scope="col"
          >
            {{ translate('task.ts') }}
            <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
          </th>
        </tr>
      </thead>
      <tbody ref="tableTask" >
        <tr v-for="(task, key) in tasks_list" :key="key">
          <td class="task-name" :data-label="translate('task.name_task')">
            {{ task.name }}
          </td>
          <td class="w7per" :data-label="translate('task.count_mm')">
            {{ task.count }}
          </td>
          <td class="w7per" :data-label="translate('task.count_success')">{{ task.count_success ?? 0 }}</td>
          <td class="w7per" :data-label="translate('task.count_pending')">{{ task.count_pending ?? 0 }}</td>
          <td class="w7per" :data-label="translate('task.count_failed')">{{ task.count_failed ?? 0 }}</td>
          <td class="w7per" :data-label="translate('task.count_cancelled')">{{ task.count_cancelled ?? 0 }}</td>

          <td :data-label="translate('task.status')">
            {{ task.status }}
          </td>
          <td :data-label="translate('task.username')">
            <router-link :to="{path: '/user/' + task.user_name}" class="link">
              {{ task.user_name }}
            </router-link>
          </td>
          <td :data-label="translate('task.ts')">
            {{ get_date(task.ts_create) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: 'MassRPCTasks',
  data () {
    return {
      tasks: [],
      filter_type: "",
      filter_asc: "asc",
    }
  },
  created () {
    this.getMassRPCTasks()
  },
  computed: {
    tasks_list() {
      return [...this.tasks].sort(this.compareNumbers)
    }
  },
  methods: {
    getMassRPCTasks(){
      this.$http.v1.getMassRPCIndex((response) => {
        if (response.data){
          this.tasks = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
  }
}

</script>
<style scoped>
.response_table table .task-name {
  text-align: left;
}
</style>
